
import { Store } from 'react-notifications-component';

export const setAlert = (title, message, severity) => {
    Store.addNotification({
      title: title,
      message: message,
      type: severity,
      insert: "top",
      container: "bottom-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true
      }});
    console.log("Showing alert", title, message)
  };